var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { ROBBERY_TYPE_CHOICES, ROBBERY_TYPE_ANSWER_TRAD_KEYS, } from '@shared/constants/robberyConstants';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
let RobberyTypeQuestion = class RobberyTypeQuestion extends QuestionComponent {
    updateClaim(type) {
        this.updateAndSaveQualification({
            qualificationPayload: { type },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.robbery.type.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.robbery.type.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.type === null) {
            return null;
        }
        return this.$tc(ROBBERY_TYPE_ANSWER_TRAD_KEYS[this.qualification.type]);
    }
    get choices() {
        return ROBBERY_TYPE_CHOICES;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], RobberyTypeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], RobberyTypeQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], RobberyTypeQuestion.prototype, "updateAndSaveQualification", void 0);
RobberyTypeQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], RobberyTypeQuestion);
export default RobberyTypeQuestion;
